var site = site || {};
var prodcat = prodcat || {};
var generic = generic || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

(function ($) {
  Drupal.behaviors.productFullShadesDropdownV1 = {
    $items: $(),
    $dropdowns: $(),
    attach: function (context) {
      var self = this;
      if (this.attached) {
        return;
      }
      this.attached = true;
      self.getMainDom(context);
      self.setEvents();
    },
    getMainDom: function (context) {
      var self = this;

      self.$items = $('.js-pdp-bundle-item', context);
      self.$dropdowns = $('.js-shade-select-wrapper', context);
    },
    setEvents: function() {
      var self = this;

      $(document).on('click', '.js-shade-select-option', function () {
        var $this = $(this);
        var selectedSkuId = $this.data('skuBaseId');
        var $parentItem;

        if (self.$items && self.$items.length) {
          $parentItem = $this.closest('.js-pdp-bundle-item');

          if ($parentItem.length && self.$items.is($parentItem)) {
            $parentItem.trigger('productBundle.skuSelect', selectedSkuId);
          }
        }
      });

      $(document).on('product.updateInvStatus', '.js-product-ui', function () {
        var $product = $(this);
        var skuBaseId = $product.data('skuBaseId');
        var skuDataL2 = prodcat.data.getSku(skuBaseId);
        var invStatus = skuDataL2 !== null ? skuDataL2.INVENTORY_STATUS : '';
        var invUpdate = invStatus && (parseInt($product.attr('data-sku-inv-status')) !== parseInt(invStatus));
        var $options = self.$dropdowns.find('.js-shade-select-option');
        if ($options.length < 1) {
            return;
        }
        // Update data attributes at product level
        if (invStatus && invUpdate) {
            $product.attr('data-sku-inv-status', invStatus);
            $product.trigger('product.updateInvStatusChange');
        }
        $options.each(function() {
            var $this = $(this);
            skuBaseId = $this.data('skuBaseId');
            skuDataL2 = prodcat.data.getSku(skuBaseId);
            invStatus = skuDataL2 !== null ? skuDataL2.INVENTORY_STATUS : '';
            $this.attr('data-inventory-status', invStatus);
        });
      });

      $(document).on('product.selectCustomShade', '.js-product-ui', function (e, skuBaseId) {
        var $options = self.$dropdowns.find('.js-shade-select-option');

        if ($options.length < 1) {
          return;
        }

        $options.each(function () {
          var $this = $(this);

          if ($this.data().skuBaseId === skuBaseId) {
            $this.trigger('click');
          }
        });
      });
    },
    attached: false
  };
})(jQuery);
